// Import model
import { UpdateBomKitRequest } from '../models/UpdateBomKitRequest';

// Import base class serializer

// Import dependency types (models and enums used in properties)

// Import dependency serializers (for complex types)

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for UpdateBomKitRequest - handles JSON serialization and deserialization with type validation
 */
export class UpdateBomKitRequestSerializer {
  /**
   * Deserializes a JSON string into a UpdateBomKitRequest instance
   */
  static deserialize(json: string): UpdateBomKitRequest {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a UpdateBomKitRequest instance
   */
  static fromObject(obj: any): UpdateBomKitRequest {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to UpdateBomKitRequest');
    }


    const instance: UpdateBomKitRequest = {
      isActive: obj['isActive'] as boolean | undefined,
      tags: obj['tags'] ? (obj['tags'] as any[]).map((item: any) =>
        item as string
      ) : [] as any,
      bins: obj['bins'] ? (obj['bins'] as any[]).map((item: any) =>
        item as string
      ) : [] as any,
      description: obj['description'] as string | undefined,
      name: obj['name'] as string | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of UpdateBomKitRequest instances
   */
  static deserializeArray(json: string): UpdateBomKitRequest[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a UpdateBomKitRequest instance to a JSON string
   */
  static serialize(instance: UpdateBomKitRequest): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a UpdateBomKitRequest instance to a plain object
   */
  static toObject(instance: UpdateBomKitRequest): any {
    return {
      'isActive': instance.isActive,
      'tags': instance.tags?.map((item: any) =>
        item
      ),
      'bins': instance.bins?.map((item: any) =>
        item
      ),
      'description': instance.description,
      'name': instance.name,
    };
  }

  /**
   * Serializes an array of UpdateBomKitRequest instances to a JSON string
   */
  static serializeArray(instances: UpdateBomKitRequest[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
